import { ORDER_METHODS, PaymentMethods } from '../../../../../../services/exports/Constants';

export default {
  title: 'Zahlungsarten',
  fields: {
    hidden_payment_methods: {
      label: 'Versteckte Zahlungsmöglichkeiten',
    },
    has_online_payments: {
      label: 'Hat Online-Zahlungen',
    },
    has_paypal_upcharge: {
      label: 'Aufpreis 3,5% extra für Paypal-Transaktionen',
    },
    has_cash_payments: {
      label: 'Hat Barzahlungen',
    },
    has_occ_cash_payments: {
      label: 'Call Center Barzahlungen aktiviert',
    },
    has_in_store_card_payments: {
      label: 'Hat Kartenzahlungen in Geschäften',
    },
    overwrite_cash_payments_to_invoice: {
      label: 'Barzahlungen als "Rechnung" kennzeichnen',
    },
  },
  payment_methods: {
    [PaymentMethods.CARD]: 'Card',
    [PaymentMethods.PAYPAL]: 'PayPal',
    [PaymentMethods.APPLE_PAY]: 'Apple pay',
    [PaymentMethods.GOOGLE_PAY]: 'GPay',
    [PaymentMethods.SOFORT]: 'Sofort',
    [PaymentMethods.IDEAL]: 'iDEAL | Wero',
    [PaymentMethods.BANCONTACT]: 'Bancontact',
    [PaymentMethods.EPS]: 'EPS',
    [PaymentMethods.P24]: 'Przelewy24',
    [PaymentMethods.BLIK]: 'BLIK',
    [PaymentMethods.TWINT]: 'TWINT',
    [PaymentMethods.VENMO]: 'Venmo',
    [PaymentMethods.WERO]: 'Wero',
    [PaymentMethods.KLARNA]: 'Klarna',
    [PaymentMethods.TRUSTLY]: 'Trustly',
    [PaymentMethods.PIX]: 'Pix',
    [PaymentMethods.NUPAY]: 'NuPay',
    [PaymentMethods.GIROPAY]: 'Giropay',
    [PaymentMethods.SEPA_DEBIT]: 'Sepa debit',
    [PaymentMethods.CASH]: 'Cash',
    [PaymentMethods.BACS_DEBIT]: 'Bacs debit',
    [PaymentMethods.PAY_BY_BANK]: 'Pay by Bank',
  },
  order_methods: {
    [ORDER_METHODS.pickup]: 'Abholung',
    [ORDER_METHODS.delivery]: 'Lieferung',
    [ORDER_METHODS.on_site]: 'Tischbestellung',
  },
  modals: {
    confirmation: {
      title: 'Sind Sie sicher?',
      description:
        'Nach der Bestätigung werden die Online-Zahlungen <strong>{{onlineState}}</strong>, und die Barzahlungen <strong>{{cashState}}</strong>',
    },
  },
  labels: {
    off: 'ausgeschaltet',
    on: 'eingeschaltet',
  },
  buttons: {
    save: 'Speichern',
    configure_online_payments: 'Online-Zahlungen einrichten',
  },
  toasts: {
    failed_to_save_changes: 'Änderungen konnten nicht gespeichert werden',
    changes_got_saved: 'Änderungen wurden gespeichert',
  },
};
